///////////////////////////////////////////////////////////////////////////////////////
//                          Copyright (c) 2020 - 2025
//                                    RXO Inc.
//                         All Rights Reserved Worldwide
//
//WARNING:  This program (or document) is unpublished, proprietary
//property of RXO Inc. and is to be maintained in strict confidence.
//Unauthorized reproduction, distribution or disclosure of this program
//(or document), or any program (or document) derived from it is
//prohibited by State and Federal law, and by local law outside of the U.S.
///////////////////////////////////////////////////////////////////////////////////////

import { analyticsView, division, userRole } from "./types";
import { rxoTlColumns } from "./rxoTlColumns";
import tlColumns from "./tlColumns";
import ltlColumns from "./ltlColumns";
import imdlColumns from "./imdlColumns";
import euColumns from "./euColumns";
import euColumnConstants from "./euColumnConstants";
import tlColumnConstants from "./tlColumnConstants";
import laneViewColumns from "./laneViewColumns";
import loadViewColumns from "./loadViewColumns";
import shipperViewColumns from "./shipperViewColumns";
import carrierViewColumns from "./carrierViewColumns";
import { shipperRatesViewColumns, shipperRatesViewColumnsV2 } from "./shipperRatesViewColumns";

const getAnalyticsGridColumns = (analyticsGridView, isCoyoteBid) => {
  switch (analyticsGridView) {
    case analyticsView.shipperView:
      return shipperViewColumns;
    case analyticsView.loadView:
      return loadViewColumns;
    case analyticsView.carrierView:
      return carrierViewColumns;
    case analyticsView.shipperRatesView:
      return isCoyoteBid ? shipperRatesViewColumns : shipperRatesViewColumnsV2;
    case analyticsView.laneView:
    default:
      return laneViewColumns;
  }
};

const getPricingGridColumns = (role, userDivision, analyticsGridView, isCoyoteBid) => {
  if (userDivision === division.eu) {
    return euColumns;
  }

  if (analyticsGridView) {
    return getAnalyticsGridColumns(analyticsGridView, isCoyoteBid);
  }

  switch (role) {
    case userRole.ltlPricingAnalyst:
      return ltlColumns;
    case userRole.imdlPricingAnalyst:
      return imdlColumns;
    case userRole.salesRep:
    case userRole.tlPricingAnalyst:
    case userRole.assetBasedPricingUser:
    default:
      if (isCoyoteBid === false || isCoyoteBid === undefined) {
        return rxoTlColumns;
      }
      return tlColumns;
  }
};

export const getColumnConstants = bidDivision =>
  bidDivision === division.eu ? euColumnConstants : tlColumnConstants;

export default getPricingGridColumns;

const PWB_HIDDEN_FIELDS = ["pwbCost", "pricingModel"];

export const filterPwbHiddenColumns = (columns, hidePwbCost) =>
  hidePwbCost ? columns.filter(c => !PWB_HIDDEN_FIELDS.includes(c.field)) : columns;
